import { useState } from 'react';

import { ProjectAbbreviatedFields } from '@playbooks/components/project/project-abbreviated-fields';
import { Button } from '@playbooks/ui/components/button';
import { DialogFooter, DialogHeader, DialogTitle } from '@playbooks/ui/components/dialog';

import { useAction } from 'hooks';

const LaunchFlowBasics = ({ model, contexts, onClose, onNext }) => {
	const [project, setProject] = useState<any>(model || {});
	const { workspace, store } = contexts;

	// Actions
	const [onSave, saveTask] = useAction(async () => {
		const response = await store.saveRecord({
			url: `${workspace.rootApi}/projects`,
			data: project,
		});
		onNext(response.data);
	});

	// Methods
	const onSubmit = e => {
		e.preventDefault();
		onSave();
	};

	// Render
	return (
		<form onSubmit={onSubmit}>
			<DialogHeader>
				<DialogTitle>Blank Project</DialogTitle>
			</DialogHeader>
			<div>
				<ProjectAbbreviatedFields project={project} setProject={setProject} />
			</div>
			<DialogFooter>
				<Button variant='secondary' onClick={onClose}>
					Cancel
				</Button>
				<Button isLoading={saveTask.running} onClick={onSave}>
					Save
				</Button>
			</DialogFooter>
		</form>
	);
};

export { LaunchFlowBasics };
